import React from 'react'
import { createRoot } from 'react-dom/client'
import ConfirmDialog from './component'

// Create a promise-based confirm function
export default (confirmation, options = {}, ok = false) => {
  return new Promise((resolve, reject) => {
    const container = document.createElement('div')
    document.body.appendChild(container)
    const root = createRoot(container)

    const cleanup = () => {
      root.unmount()
      document.body.removeChild(container)
    }

    const handleProceed = () => {
      cleanup()
      resolve(true)
    }

    const handleCancel = () => {
      cleanup()
      reject(new Error('User cancelled'))
    }

    root.render(
      <ConfirmDialog
        show
        proceed={handleProceed}
        cancel={handleCancel}
        dismiss={handleCancel}
        confirmation={confirmation}
        confirmLabel={options.confirmLabel}
        cancelLabel={options.cancelLabel}
        ok={ok}
      />
    )
  })
}
